import { BACK_BUTTON } from 'components/common/ActionBar/constants';
import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const LineCommitmentsFiltersDataSource = [
    {
        text: 'Lines With Committed Quantity',
        value: false,
    },
    {
        text: 'Lines With No Committed Quantity',
        value: true,
    },
];

const MappingFilter = {
    false: true,
    true: false
};

export const quantityFilter = (filter) => (Array.isArray(filter) ?
filter[0] === '!' ? MappingFilter[`${filter?.pop()}`] : filter?.pop()
: '');

export const columns = [
    {
        dataField: 'DocumentType',
        caption: 'Type',
        allowSorting: false,
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        allowEditing: false,
        isEditable: false,
        allowHeaderFiltering: false,
    },
    {
        dataField: 'ProductionOrder',
        caption: 'Production Order',
        visible: false
    },
    {
        dataField: 'ProductionOrderBOMLineNumber',
        caption: 'ProductionOrder BOM LineNumber',
        visible: false
    },
    {
        dataField: 'ProductionOrderLineNumber',
        caption: 'ProductionOrder LineNumber',
        visible: false
    },
    {
        dataField: 'SalesOrder',
        caption: 'Sales Order',
        visible: false
    },
    {
        dataField: 'SalesOrderLineNumber',
        caption: 'SalesOrder Line Number',
        visible: false
    },
    {
        dataField: 'ServiceOrderLineNumber',
        caption: 'ServiceOrder Line Number',
        visible: false
    },
    {
        dataField: 'DocumentNumber',
        caption: 'Document',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        allowEditing: false,
        isEditable: false,
        allowSorting: false,
        allowHeaderFiltering: false,
    },
    {
        dataField: 'Reference',
        caption: 'Reference',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        allowSorting: false,
        allowEditing: false,
        isEditable: false,
        allowHeaderFiltering: false,
    },
    {
        dataField: 'UncommittedQuantity',
        caption: 'Uncommitted ',
        format: '#0.00',
        allowSorting: false,
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        allowEditing: false,
        isEditable: false,
        allowHeaderFiltering: false,
    },
    {
        dataField: 'CommittedQuantity',
        caption: 'Committed',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md1,
        format: '#0.00',
        allowSorting: false,
        allowEditing: true,
        isEditable: true,
        alignment: 'right',
        filterType: 'exclude',
        headerFiltersDataSource: LineCommitmentsFiltersDataSource,
    },
    {
        dataField: 'UserId',
        caption: 'User ID',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.sm1,
        allowSorting: false,
        allowEditing: false,
        isEditable: false,
        alignment: 'left',
        allowHeaderFiltering: false,
    },
    {
        dataField: 'EarliestDueDate',
        caption: 'Date',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        allowSorting: false,
        Format: 'dd/MM/yyyy',
        isEditable: false,
        alignment: 'left',
        allowHeaderFiltering: false,
    },
    {
        dataField: 'CustomerDescription',
        caption: 'Customer/ Description',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        allowSorting: false,
        allowEditing: false,
        isEditable: false,
        allowHeaderFiltering: false,
    },
];

export const ActionBarIcons = {
    leftIcons: [BACK_BUTTON],
    centerIcons: [],
    rightIcons: []
};

export const LineCommitmentHeaderFilterHeight = '230';
export const LineCommitmentHeaderFilterWidth = '312';
